import { createRouter, createWebHashHistory } from "vue-router";
import Inicio from "./pages/Inicio/Inicio.vue";
import store from './store'

const routes = [
    {
        path: "/",
        name: "inicio",
        component: Inicio,
    },
    {
        path: "/admins/admin",
        name: "admins_admin",
        component: () => import("./pages/AdminsAdmin.vue"),
    },
    {
        path: "/pur",
        name: "pur",
        component: () => import("./pages/Pur.vue"),
    },
    {
        path: "/clientes/admin",
        name: "clientes_admin",
        component: () => import("./pages/ClientesAdmin.vue"),
    },
    {
        path: "/clientes/managers",
        name: "clientes_managers",
        component: () => import("./pages/ClientesManagers.vue"),
    },
    {
        path: "/clientes/tipos",
        name: "clientes_tipos",
        component: () => import("./pages/ClientesTipos.vue"),
    },
    {
        path: "/clientes/validar",
        name: "clientes_validar",
        component: () => import("./pages/ClientesValidar.vue"),
    },
    {
        path: "/clientes/vencimientos",
        name: "clientes_vencimientos",
        component: () => import("./pages/ClientesVencimientos.vue"),
    },
    {
        path: "/proveedores/admin",
        name: "proveedores_admin",
        component: () => import("./pages/ProveedoresAdmin.vue"),
    },
    {
        path: "/proveedores/managers",
        name: "proveedores_managers",
        component: () => import("./pages/ProveedoresManagers.vue"),
    },
    {
        path: "/proveedores/pdv",
        name: "proveedores_pdv",
        component: () => import("./pages/ProveedoresPDV.vue"),
    },
    {
        path: "/proveedores/tipos",
        name: "proveedores_tipos",
        component: () => import("./pages/ProveedoresTipos.vue"),
    },
    {
        path: "/proveedores/validar",
        name: "proveedores_validar",
        component: () => import("./pages/ProveedoresValidar.vue"),
    },
    {
        path: "/proveedores/vencimientos",
        name: "proveedores_vencimientos",
        component: () => import("./pages/ProveedoresVencimientos.vue"),
    },
    {
        path: "/usuarios/admin",
        name: "usuarios_admin",
        component: () => import("./pages/UsuariosAdmin.vue"),
    },
    {
        path: "/usuarios/tipos",
        name: "usuarios_tipos",
        component: () => import("./pages/UsuariosTipos.vue"),
    },
    {
        path: "/usuarios/validar",
        name: "usuarios_validar",
        component: () => import("./pages/UsuariosValidar.vue"),
    },
    {
        path: "/usuarios/vencimientos",
        name: "usuarios_vencimientos",
        component: () => import("./pages/UsuariosVencimientos.vue"),
    },
    {
        path: "/usuarios/importar",
        name: "usuarios_importar",
        component: () => import("./pages/UsuariosImportar.vue"),
    },
    {
        path: "/usuarios/solicitudes_credito",
        name: "usuarios_solicitudes_credito",
        component: () => import("./pages/UsuariosSolicitudesCredito.vue"),
    },
    {
        path: "/documentos/tipos",
        name: "documentos_tipos",
        component: () => import("./pages/DocumentosTipos.vue"),
    },
    {
        path: "/vehiculos/admin",
        name: "vehiculos_admin",
        component: () => import("./pages/VehiculosAdmin.vue"),
    },
    {
        path: "/ayuda/categorias",
        name: "ayuda_categorias",
        component: () => import("./pages/AyudaCategorias.vue"),
    },
    {
        path: "/ayuda/contenidos",
        name: "ayuda_contenidos",
        component: () => import("./pages/AyudaContenidos.vue"),
    },
    {
        path: "/notificaciones",
        name: "notificaciones",
        component: () => import("./pages/Notificaciones.vue"),
    },
    {
        path: "/soporte/mensajes",
        name: "soporte_mensajes",
        component: () => import("./pages/Contacto.vue"),
    },
    {
        path: "/tycs/",
        name: "tycs",
        component: () => import("./pages/TYCsAdmin.vue"),
    },
    {
        path: "/cliente/documentacion",
        name: "cliente_documentacion",
        component: () => import("./pages/ClienteDocumentacion.vue"),
    },
    {
        path: "/cliente/usuarios/admin",
        name: "cliente_usuarios_admin",
        component: () => import("./pages/ClienteUsuariosAdmin.vue"),
    },
    {
        path: "/cliente/usuarios/validar",
        name: "cliente_usuarios_validar",
        component: () => import("./pages/ClienteUsuariosValidar.vue"),
    },
    {
        path: "/cliente/usuarios/vencimientos",
        name: "cliente_usuarios_vencimientos",
        component: () => import("./pages/ClienteUsuariosVencimientos.vue"),
    },
    {
        path: "/cliente/usuarios/solicitudes_credito",
        name: "cliente_usuarios_solicitudes_credito",
        component: () => import("./pages/ClienteUsuariosSolicitudesCredito.vue"),
    },
    {
        path: "/cliente/usuarios/credito_default",
        name: "cliente_usuarios_credito_default",
        component: () => import("./pages/ClienteUsuariosCreditoDefault.vue"),
    },
    {
        path: "/cliente/vehiculos/admin",
        name: "cliente_vehiculos_admin",
        component: () => import("./pages/ClienteVehiculosAdmin.vue"),
    },
    {
        path: "/proveedor/documentacion",
        name: "proveedor_documentacion",
        component: () => import("./pages/ProveedorDocumentacion.vue"),
    },
    {
        path: "/proveedor/pdv",
        name: "proveedor_pdv",
        component: () => import("./pages/ProveedorPDV.vue"),
    },
    // {
    //   path: "/proveedor/generar_qr",
    //   name: "proveedor_generar_qr",
    //   component: () => import("./pages/ProveedorGenerarQR.vue"),
    // },

    {
        path: "/usuario/documentacion",
        name: "usuario_documentacion",
        component: () => import("./pages/UsuarioDocumentacion.vue"),
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

router.beforeEach(function (to, from, next) {
    window.scrollTo(0, 0);
    next();
});

export const chequearRuta = (ruta) => {

    let valida = true;

    if (store.state.auth.usuario.nivel === 2 && ruta !== 'inicio') {
        if (store.state.auth.usuario.permisos.todo !== true && store.state.auth.usuario.permisos.modulos.some(modulo => modulo.id === ruta && (modulo.read === true || modulo.write === true)) === false) {
            valida = false;
        }        
    }
    if (ruta === 'admins_admin' && store.state.auth.usuario.nivel !== 1) {
        valida = false;
    }

    if (valida === false) {
        console.log(`${ruta} es una ruta inválida para este usuario`);
        return false;
    }
}

// lo exportamos de esta manera, como un plugin, para poder recibir "app" desde main.js
export default {
    install(app) {
        router.install(app)

        router.beforeEach(async (to, from) => {

            console.log(`🚦 Router from ${from.path} ${from.name ? `(${from.name.toString()}) ` : ''}to ${to.path} ${to.name ? `(${to.name.toString()})` : ''}`);

            const isLogueado = store.getters['auth/isLogueado'];
            const isLogueadoPDV = store.getters['auth/isLogueadoPDV'];
            const hasToken = store.getters['auth/hasToken'];

            if (isLogueado == false && isLogueadoPDV == false && hasToken == true) {
                console.log('CHEQUEANDO DATOS!')
                if (app.config.globalProperties.$server === 'backend') {
                    await store.dispatch('auth/obtenerDatos')
                } else {
                    await store.dispatch('auth/obtenerDatosPDV')
                }
            }

            if (chequearRuta(to.name) === false) {
                return {
                    name: "inicio",
                };
            }

        });
    },
};
